(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.order-received-page');
    if (!root) {
      return;
    }

    root.querySelectorAll('[data-order-summary-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const section = button.closest('[data-order-summary-section]');
        if (!section) {
          return;
        }

        const extra = section.querySelector('[data-order-summary-extra]');
        const label = button.querySelector('[data-order-summary-toggle-label]');
        const expanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (extra) {
          extra.hidden = expanded;
        }

        if (label) {
          label.textContent = expanded
            ? (label.dataset.showAll || 'Show all')
            : (label.dataset.showLess || 'Show less');
        }
      });
    });

    root.querySelectorAll('[data-order-summary-toggle-label]').forEach((label) => {
      label.dataset.showAll = label.textContent.trim();
      label.dataset.showLess = root.dataset.showLess || 'Show less';
    });
  });
})();
